import { render, staticRenderFns } from "./Ideas-Create.vue?vue&type=template&id=632b515a&scoped=true&"
import script from "./Ideas-Create.vue?vue&type=script&lang=js&"
export * from "./Ideas-Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632b515a",
  null
  
)

export default component.exports